<template>
  <div class="search">
  <Autocomplete></Autocomplete>
  </div>
</template>

<script>
import Autocomplete from './Autocomplete'
//import AutocompleteGrouped from './AutocompleteGrouped'

export default {
  name: 'search',
  components: {
    Autocomplete,
    //AutocompleteGrouped
  },
  data () {
    return {
    }
  }
}

</script>

<style scoped>
</style>
